import { Outlet, Route, Routes } from 'react-router-dom';
import WorkingInProgress from '../otherpages/WorkingInProgress/WorkingInProgress';

export default function Productivity() {
	return (
		<Routes>
			<Route path="/*" element={<Outlet />}>
				<Route path="feeding" element={<WorkingInProgress />} />
				<Route path="animal-wealth" element={<WorkingInProgress />} />
				<Route path="final-product" element={<WorkingInProgress />} />
			</Route>
		</Routes>
	);
}
